<template>
  <v-card>
    <v-card-title>
      Video Projects
      <v-spacer v-if="user.admin == true"></v-spacer>
      <v-btn v-if="user.admin == true" small color="red darken-2" dark @click="deleteProjects" >Delete Selected</v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      <v-flex xs12 sm12 v-if="projectError != ''" class="mb-2">
        <span style="color: red;" >{{ projectError }}</span>
      </v-flex>
    </v-card-title>
    <v-data-table :headers="user.admin== true ? headers : editorHeaders" :items="projects" :pagination.sync="pagination" v-model="selected" select-all item-key="_id" class="elevation-1" :total-items="amount" :rows-per-page-items="listSize" >
      <template slot="headers" slot-scope="props">
        <tr>
          <th v-if="user.admin == true || user.editor == true || user.manager == true">
            <v-checkbox
              primary
              hide-details
              @click.native="toggleAll"
              :input-value="props.all"
              :indeterminate="props.indeterminate"
            ></v-checkbox>
          </th>
          <th v-for="header in props.headers" :key="header.text"
            :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.text=='Action' ? 'text-xs-center' : 'text-xs-left']"
            @click="changeSort(header.value)"
          > 
            {{ header.text }}
            <v-icon>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td v-if="user.admin == true || user.editor == true || user.manager == true">
            <v-checkbox
              primary
              hide-details
              :input-value="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.title }}</td>
          <td v-html="trimDescription(props.item.description)"></td>
          <td class>{{ props.item.category }}</td>
          <td class>{{ props.item.expertName }}</td>
          <td class v-if="props.item.location != null">{{ props.item.location.locationName }}</td>
          <td v-else></td>
          <td class>            
            <span v-if="props.item.active==true" style="color:green">{{props.item.status}}</span>
            <span v-if="props.item.active==false" style="color:red">inactive</span>
          </td>
          <td class>{{ props.item.createdAt | moment("Do MMM YYYY") }}</td>
          <td class>
            <v-btn color="blue darken-2" v-if="props.item.active==false" small flat @click="activateModal(props.item)">
              Activate
            </v-btn>

             <v-btn color="red" v-if="props.item.active==true" small flat @click="deactivateModal(props.item)">
              Deactivate
            </v-btn>
          </td>
          <td>
            <v-btn icon @click="editModal(props.item)">
              <v-icon color="orange darken-2">edit</v-icon>
            </v-btn>
          </td>
          <td class v-if="user.admin== true">
            <v-btn icon @click="deleteModal(props.item)">
              <v-icon color="red">delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <v-alert
        v-slot:no-results
        :value="true"
        color="error"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

    <!-- delete dialog -->
    <v-dialog v-model="delete_dialog" max-width="750px">
      <v-toolbar class="red" dark dense>
        <v-toolbar-title>Delete Project</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="delete_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
              <h5>Are you sure you want to delete this project?</h5>
            </v-flex>
            <v-flex xs12 sm12 v-if="projectError != ''" class="mb-2">
              <span style="color: red;" >{{ projectError }}</span>
            </v-flex>
            <v-flex xs6 sm6>
              <v-text-field label="Title" v-model="dataItem.title"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Expertise" v-model="dataItem.category"></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-btn color="red" class="right" small dark @click="deleteProject" :loading="loader">
                <v-icon left>delete</v-icon>Yes
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of delete  -->


    <!-- activate dialog -->
    <v-dialog v-model="activate_dialog" max-width="750px">
      <v-toolbar class="primary" dark dense>
        <v-toolbar-title>Activate Project</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="activate_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
            </v-flex>
            <v-flex xs12 sm12 v-if="projectError != ''" class="mb-2">
              <span style="color: red;" >{{ projectError }}</span>
            </v-flex>
            <v-flex xs6 sm6>
              <v-text-field label="Title" v-model="dataItem.title"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Expertise" v-model="dataItem.category"></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-btn color="primary" class="right" small dark @click="activate" :loading="loader">
                <v-icon left>thumb_up</v-icon> Activate
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of activate modal  -->


        <!-- deactivate dialog -->
    <v-dialog v-model="deactivate_dialog" max-width="750px">
      <v-toolbar class="orange darken-2" dark dense>
        <v-toolbar-title>Deactivate Project</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="deactivate_dialog=false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 class="pa-2">
            </v-flex>
            <v-flex xs12 sm12 v-if="projectError != ''" class="mb-2">
              <span style="color: red;" >{{ projectError }}</span>
            </v-flex>
            <v-flex xs6 sm6>
              <v-text-field label="First Name" v-model="dataItem.title"></v-text-field>
            </v-flex>

            <v-flex xs6 sm6>
              <v-text-field label="Last Name" v-model="dataItem.category"></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-btn color="orange darken-2" class="right" small dark @click="deactivate" :loading="loader">
                <v-icon left>thumb_down</v-icon> Deactivate
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- end of deactivate modal  -->

    <!-- Description editing -->
    <div class="modal-vue">
      <!-- overlay -->
      <div class="overlay" v-if="editDialog" @click="closeeditModal"></div>
      <!-- modal -->
      <div class="modal" v-if="editDialog">
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Edit Description</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click="closeeditModal">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap> 
                <v-flex xs12 sm12 v-if="projectError != ''" class="mb-2">
                  <span style="color: red;" >{{ projectError }}</span>
                </v-flex> 
                <!-- snackbar -->
                <snackbar ref="mySnackbar"></snackbar>
                <!-- end of snackbar -->              
                <v-flex xs12>                  
                  <label>Project Description</label>
                  <tinymce 
                    v-validate="'required'"
                    :error-messages="errors.collect('description')"
                    id="description"
                    data-vv-name="description"
                    v-model="editItem.description"
                    label="Project Description"
                    :other_options="tinyOptions"
                    v-on:editorInit="initCallBack"
                  ></tinymce>
                </v-flex>
                <v-flex xs12 sm12 v-if="tinymcError != ''" class="mb-2">
                  <span class="v-messages theme--light error--text"><strong>Min allowed text is 150 words; please add more content. </strong></span>
                </v-flex>     

                <v-flex xs12>
                  <v-btn class="btnColor" dark @click="save">
                    <v-icon left>save</v-icon>Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <!-- End -->
    
  </v-card>
</template>

<script>
import Snackbar from "@/components/global/snackbar.vue";
import { mapGetters } from "vuex";
import { trimDescription } from "@/common/methods.js";
import tinymce from 'vue-tinymce-editor';
export default {
  components: {
    tinymce,
    Snackbar
  },
  computed: {
    ...mapGetters(["user"])
  },
  /*props: {
    projects: {
      type: Array,
      default: [],
      required: true
    },
  },*/
  data() {
    return {
      search: "",
      delete_dialog: false,
      activate_dialog: false,
      deactivate_dialog: false,
      pagination: {rowsPerPage: 25,page: 1, sortBy: 'title'},
      dataItem: {},
      listSize: [5,10,25,50,100,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
      loader: false,
      headers: [
        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title"
        },
        { text: "Description", value: "description", sortable: true },
        { text: "Expertise Category", value: "category", sortable: true },
        { text: "Expert", value: "expertName", sortable: true },
        { text: "Location", value: "location.locationName", sortable: true },
        { text: "Status", value: "status", sortable: true },
        { text: "Date Created", value: "createdAt", sortable: true },
        { text: "Action", value: "activation", sortable: true },
        { text: "Edit", value: "Edit", sortable: false },
        { text: "Delete", value: "action", sortable: false }
      ],
      editorHeaders: [
        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title"
        },
        { text: "Description", value: "description", sortable: true },
        { text: "Expertise Category", value: "category", sortable: true },
        { text: "Expert", value: "expertName", sortable: true },
        { text: "Location", value: "location.locationName", sortable: true },
        { text: "Status", value: "status", sortable: true },
        { text: "Date Created", value: "createdAt", sortable: true },
        { text: "Action", value: "activation", sortable: true },
        { text: "Edit", value: "Edit", sortable: false },
      ],
      projectError: '',
      selected: [],
      editDialog: false,
      editItem: {},
      tinyOptions: {
        menubar:false,
        toolbar1:"formatselect | bold italic underline strikethrough forecolor backcolor | alignleft aligncenter alignright alignjustify | numlist bullist | removeformat",
        branding: false
      },
      amount: 0,
      projects: [],
      tinymcError: '',
    };
  },
  methods: {
    trimDescription,
    editModal(item) {
      this.editItem = Object.assign({}, item);
      this.editDialog = true;
      this.projectError = '';
    },
    closeeditModal() {
      this.editDialog = false;
      this.projectError = '';
    },
    initCallBack(e) {
      window.tinymce.editors["description"].setContent(this.editItem.description);
    },
    deleteModal(item) {
      this.dataItem = Object.assign({}, item);
      this.delete_dialog = true;
      this.projectError = '';
    },
    activateModal(item) {
      this.dataItem = Object.assign({}, item);
      this.activate_dialog = true;
      this.projectError = '';
    },
    deactivateModal(item) {
      this.dataItem = Object.assign({}, item);
      this.deactivate_dialog = true;
      this.projectError = '';
    },
    deleteProject(id) {
      const project = this.dataItem;
      const projectUser = this.user._id;
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("remove", "/videoproject/" + projectUser + '/' + project._id)
        .then(res => {
          if(res.state) {
            self.loader = false;
            location.reload();
          } else {
            self.projectError = res.msg;
            self.loader = false;
          }
        })
        .finally(() => {});
    },
    activate() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/videoproject/activate", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    deactivate() {
      this.loader = true;
      const data = this.dataItem;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/videoproject/deactivate", data })
        .then(res => {
          if (res.state) {
            self.loader = false;
            location.reload();
          }
        })
        .finally(() => {});
    },
    toggleAll () {
      if (this.selected.length) { 
        this.selected = []
      } else {
        this.selected = this.projects.slice()
      }
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    deleteProjects() {
      const projects = [];
      this.selected.forEach((value, index) => {        
        projects.push(value._id);
      });
      this.loader = true;
      const data = {
        projects: projects
      };
      const self = this;
      const res = this.$store        
        .dispatch("post", { url: "/videoproject/delete/" + self.user._id, data })
        .then(res => {
          if(res.state) {
            self.loader = false;
            location.reload();
          } else {
            self.projectError = res.msg;
            self.loader = false;
          }
        })
        .finally(() => {});   
    },
    save() {  
      var count = this.countWords();           
      if(this.editItem.description == undefined || this.editItem.description == null || this.editItem.description.length == 0){
        this.$refs.mySnackbar.show("Please enter video project description", "red");
      } else if(count < 150) {
        this.tinymcError = 'min word error';
      } else{
        this.tinymcError = '';
        const data = this.editItem;
        this.loader = true;
        const self = this;
        const res = this.$store
          .dispatch("put", { url: "/videoproject/update-description/"+this.editItem._id+"/"+self.user._id, data })        
          .then(res => {
            if(res.state) {
              self.loader = false;
              location.reload();
            } else {
              self.projectError = res.msg;
              self.loader = false;
            }
          });
      }      
    },
    fetchData() {
        return new Promise((resolve, reject) => {
            let search = this.search.trim().toLowerCase();
            const {rowsPerPage, page} = this.pagination;
            if(search !== '') {
              search = `/`+search;  
            }
            let sortBy = '/'+this.pagination.sortBy;
            let order  = -1;
            if(this.pagination.descending == false) {
              order = 1;
            }
            let sortOrder = '/'+order;
            this.$store.dispatch("get", `/videoproject/admin`+sortBy+sortOrder+'/'+page+`/`+rowsPerPage+search).then(res => {
              this.projects = res.projects;
              const {
                  sortBy,
                  descending,
                  page,
                  rowsPerPage
              } = this.pagination;
              this.amount = res.amount;
              resolve();
            });
        });
    },
    countWords() {
        const wordcount = window.tinymce.activeEditor.plugins.wordcount;
        return wordcount.getCount();
    },
  },
  watch: {
    pagination: {
        handler() {
            this.fetchData();
        },
        deep: true
    },
    search() {
        this.pagination.page = 1;
        this.pagination.rowsPerPage = 25;
        this.fetchData();
    }
  },
  mounted() {
        this.fetchData();
  }
    /*computed: {                                    
        pages () {                                       
            return this.pagination.rowsPerPage ? Math.ceil(this.amount / this.pagination.rowsPerPage) : 0;
        }                                                                                                                                                           
    }*/
};
</script>
<style scoped>
.modal-vue .overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
}

.modal-vue .modal {  
  z-index: 9999;    
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 750px;
}

.modal-vue .close{
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>